import { DollarSign, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getReconciliationText } from "@/lib/subscriptionDisplay";
import { getPaymentContext, formatLastPayment } from "@/lib/utils";
import { type Subscription } from "@/types/subscription";

interface QuickPaymentActionProps {
  subscription: Subscription;
  shouldShow: boolean;
  onMarkAsPaid: () => void;
  formatAmount: () => string;
  getFrequencyText: () => string;
}

export const QuickPaymentAction = ({
  subscription,
  shouldShow,
  onMarkAsPaid,
  formatAmount,
  getFrequencyText,
}: QuickPaymentActionProps) => {
  if (!shouldShow) return null;

  return (
    <div className="-mx-6 -mb-6 mt-4 flex min-h-[76px] items-center justify-between border-t border-primary/20 bg-primary/10 p-4">
      <div className="flex items-center space-x-2">
        <DollarSign className="h-4 w-4 text-primary" />
        <div>
          <span className="text-sm font-medium text-primary">
            {getReconciliationText(subscription)}
          </span>
          <div className="mt-1 flex items-center space-x-2">
            <p className="text-xs text-muted-foreground">
              {formatAmount()} • {getFrequencyText()}
            </p>
            {getPaymentContext(subscription).hasHistory && (
              <span className="text-xs text-muted-foreground">
                • Last:{" "}
                {
                  formatLastPayment(getPaymentContext(subscription).lastPayment)
                    .shortText
                }
              </span>
            )}
          </div>
        </div>
      </div>
      <Button
        onClick={onMarkAsPaid}
        size="sm"
        className="btn-premium shadow-glow"
      >
        <CheckCircle2 className="mr-2 h-4 w-4" />
        Mark as Paid
      </Button>
    </div>
  );
};
